var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1731_1279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0001 6.49998C5.21483 6.78705 5.48878 7.02457 5.80337 7.19645C6.11797 7.36833 6.46585 7.47054 6.82342 7.49615C7.181 7.52176 7.53989 7.47017 7.87577 7.34487C8.21165 7.21958 8.51666 7.02352 8.7701 6.76998L10.2701 5.26998C10.7255 4.79848 10.9775 4.16697 10.9718 3.51148C10.9661 2.85599 10.7032 2.22896 10.2396 1.76544C9.77613 1.30192 9.14909 1.03899 8.4936 1.0333C7.83811 1.0276 7.20661 1.27959 6.7351 1.73498L5.8751 2.58998M7.0001 5.49998C6.78537 5.21292 6.51142 4.97539 6.19682 4.80351C5.88223 4.63163 5.53435 4.52942 5.17677 4.50382C4.8192 4.47821 4.46031 4.5298 4.12443 4.65509C3.78855 4.78038 3.48354 4.97645 3.2301 5.22998L1.7301 6.72998C1.2747 7.20149 1.02272 7.83299 1.02841 8.48849C1.03411 9.14398 1.29703 9.77101 1.76055 10.2345C2.22407 10.698 2.85111 10.961 3.5066 10.9667C4.16209 10.9724 4.79359 10.7204 5.2651 10.265L6.1201 9.40998",
    stroke: "#3474E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1731_1279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.0fa0dfa6594d473a84bd890bef179c5b.svg";
export { ForwardRef as ReactComponent };